function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.01426 11.4292H19.5098C19.7861 11.4292 20 11.2053 20 10.9365C20 10.6589 19.7772 10.4439 19.5098 10.4439H19.2424V7.55974C19.2424 7.04023 18.8235 6.61925 18.3066 6.61925H16.1408C15.6239 6.61925 15.205 7.04023 15.205 7.55974V10.4439H13.1462V5.38318C13.1462 4.80097 12.6738 4.32625 12.0945 4.32625H10.1604C9.58111 4.32625 9.10874 4.80097 9.10874 5.38318V10.4439H7.06774V1.76454C7.06774 1.07484 6.50624 0.501594 5.81996 0.501594H4.2959C3.60071 0.501594 3.03922 1.06589 3.03922 1.76454V10.4439H2.01426C1.44385 10.4439 0.989305 9.97814 0.989305 9.41384V0.492637C0.989305 0.223926 0.766488 0 0.490196 0C0.213904 0 0 0.223926 0 0.492637V9.40489C0 10.5245 0.900178 11.4292 2.01426 11.4292ZM4.02852 10.4439V1.49583H6.08734V10.4439H4.02852ZM10.1159 10.4439V5.32048H12.1747V10.4439H10.1159ZM16.1943 10.4439V7.61348H18.2531V10.4439H16.1943Z",
  fill: "#646464"
});

const SvgDashboard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 12,
  viewBox: "0 0 20 12",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.d39aca44.svg";
export { ForwardRef as ReactComponent };